module.exports = __webpack_public_path__ + "img/sBuffK_193x205.6e3547ce.png";